import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AppConfig } from './constants';
import {isArray, isObject} from 'util';

@Injectable()
export class LoginService {
  private apiUrl = this.appConfig.API_URL_PROD;
  private apiUrlLogin = this.appConfig.API_URL_WEB;
  private pathUrlLogin = this.appConfig.PATH_URL_WEB;

  private headers = {headers: new HttpHeaders({ 'Content-Type': 'application/json' })};
  private headersLogin = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

  constructor(public http: HttpClient, private appConfig: AppConfig) {

  }

  login(params){
    let user = params.username.replace('&', '%26');
    let pw = params.password.replace('&', '%26');

    //const body = 'username='+user+'&password='+pw+'&grant_type='+params.grant_type;

    const paramsHttp = new HttpParams()
    .append('username', user)
    .append('password', pw )
    .append('client_id', 'aspnetcore_spa')
    .append('grant_type', 'password')
    .append(
      'scope',
      'openid email phone profile offline_access roles aspnetcore_api'
    );

    return new Promise((resolve, reject) => {

      this.http.post(this.pathUrlLogin+'connect/token', paramsHttp, this.headersLogin )
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  createHeader(tmpToken : any ) {

    let token = localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    this.headers = {headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization':  token
    })};// , 'token': token
  }


  menus(userId){
    return new Promise((resolve, reject) => {

      this.createHeader(null);

      this.http.get(this.apiUrlLogin+'Usuarios/'+userId+'/Menus', this.headers )
        .subscribe(res => {
          const idx = res['Entidades'].findIndex(x => x.IdMenu == 12);
          console.log(" idx "+idx);
          if(idx > 0){
            localStorage.setItem('btnAprobacionExtranjero','true');
          }
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  /*
  *Recovery desde pantalla de login
  */
  recover(params){

    //this.createHeader(null);
    const body = 'Usuario='+params.userMail;

    // console.log(params, body);
    // console.log(isObject(params));
    // console.log(isArray(params));
    // console.log(isObject(body));
    // console.log(isArray(body));
    //let headers = {headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })};

    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlLogin + 'ResetPassword', params, this.headers )
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          console.warn(err);
          reject(err);
        });
    });
  }

  changePass(params, userId, token){
    this.createHeader(null);

    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'Usuarios/CambiarPassword', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  signup(params){
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrl+'user/signup', params, this.headers)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  validateRecovery(params){
    const header = {headers: new HttpHeaders({ 'Content-Type': 'application/json' })};

    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlLogin+'ResetPassword/ResetPasswordValidate', params, header)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

  updateNewPassword(params){

    const header = {headers: new HttpHeaders({ 'Content-Type': 'application/json' })};
    return new Promise((resolve, reject) => {
      this.http.post(this.apiUrlLogin+'ResetPassword/ResetPasswordConfirm', params, header)
        .subscribe(res => {
          resolve(res);
        }, (err) => {
          reject(err);
        });
    });
  }

}
